// @flow

export const ANCILLARIES_3RD_ERROR = "ANCILLARIES_3RD_ERROR"

export const CHECK_ANCILLARIES_LOADING = "CHECK_ANCILLARIES_LOADING"
export const CHECK_ANCILLARIES_ERROR = "CHECK_ANCILLARIES_ERROR"

export type Ancillary = {
  name: string,
  service: string,
  type: number,
  data: {
    is_applicable: boolean,
    price_info: {
      base_price: number,
      service_fee: number,
      currency: string,
    },
  },
}

type PriceInput = {
  amount: number,
  base: number,
  currency: string,
  merchant: number,
  service: number,
  service_flat: number,
}

export type AncillarySegment = {
  is_applicable: boolean,
  price: PriceInput,
  price_info: {
    base_price: number,
    service_fee: number,
    currency: string,
  },
}

export type AncillaryPerSegment = {
  name: string,
  service: string,
  type: number,
  data: AncillarySegment[],
}

export type generalActions = {|
  type:
    | typeof ANCILLARIES_3RD_ERROR
    | typeof CHECK_ANCILLARIES_ERROR
    | typeof CHECK_ANCILLARIES_LOADING,
  loading?: boolean,
  error?: boolean,
|}

export const ancillaries3rdError = () => ({
  type: ANCILLARIES_3RD_ERROR,
})

export const checkAncillariesLoading = (loading: boolean = true) => ({
  type: CHECK_ANCILLARIES_LOADING,
  loading,
})

export const checkAncillariesError = (error: boolean = true) => ({
  type: CHECK_ANCILLARIES_ERROR,
  error,
})
